import { useEffect } from 'react'
import { UPDATE_SHOW_NAVIGATION } from 'TypeDefs/AppContext'
import { useAppDispatch } from 'Context/AppContext/AppContext'

export const useHideNavigation = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch({
      type: UPDATE_SHOW_NAVIGATION,
      showNavigation: false,
    })
  }, [dispatch])
}
